export const USER_STATUS_CHANGE = "USER_STATUS_CHANGE";
export const SET_USER_SESSION = "SET_USER_SESSION";
export const CLEAR_USER_SESSION = "CLEAR_USER_SESSION";
export const NEW_CONVERSATION = "NEW_CONVERSATION";
export const NEW_MESSAGE = "NEW_MESSAGE";
export const SET_ACTIVE_CONVERSATION = "SET_ACTIVE_CONVERSATION";
export const DISPOSE_CONVERSATION = "DISPOSE_CONVERSATION";
export const UPDATE_CONVERSATION_META = "UPDATE_CONVERSATION_META";
export const INITIALIZE_CONVERSATIONS = "INITIALIZE_CONVERSATIONS";
export const SET_CLOSED_CONVERSATIONS = "SET_CLOSED_CONVERSATIONS";
export const SET_CLOSED_CONVERSATION_MESSAGES =
  "SET_CLOSED_CONVERSATION_MESSAGES";
export const LOAD_OLD_CONVERSATIONS = "LOAD_OLD_CONVERSATIONS";
export const CHANGE_AGENT_VIEW = "CHANGE_AGENT_VIEW";
export const CHANGE_AGENT_TAB = "CHANGE_AGENT_TAB";
export const TRANSFER_CONVERSATION = "TRANSFER_CONVERSATION";
export const INITIALIZE_TRANSFERRED_CONVERSATIONS =
  "INITIALIZE_TRANSFERRED_CONVERSATIONS";
export const SET_TRANSFERRED_CONVERSATION_MESSAGES =
  "SET_TRANSFERRED_CONVERSATION_MESSAGES";
export const SET_DELIVERY_INFO_IN_MESSAGE = "SET_DELIVERY_INFO_IN_MESSAGE";
export const SET_SEEN_INFO_IN_MESSAGE = "SET_SEEN_INFO_IN_MESSAGE";
export const SET_SUGGESTION_MESSAGE = "SET_SUGGESTION_MESSAGE";
export const SHOW_USER_ALERT = "SHOW_USER_ALERT";
export const REMOVE_USER_ALERT = "REMOVE_USER_ALERT";
export const LOAD_ATTACHMENTS = "LOAD_ATTACHMENTS";
export const CHANGE_ADMIN_VIEW_BU = "CHANGE_ADMIN_VIEW_BU";
export const CHANGE_ADMIN_VIEW_SECTION = "CHANGE_ADMIN_VIEW_SECTION";
export const UPDATE_SUGGESTIONS_FOR_MESSAGE = "UPDATE_SUGGESTIONS_FOR_MESSAGE";
export const SET_LOCATION_FOR_DEALER_SUGGESTIONS =
  "SET_LOCATION_FOR_DEALER_SUGGESTIONS";
export const AGENT_BACKGROUND_MESSAGE_COUNT = "AGENT_BACKGROUND_MESSAGE_COUNT";
export const SET_OPEN_CONVERSATION_MESSAGES = "SET_OPEN_CONVERSATION_MESSAGES";
